(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hrny-tee-landing"]) return;
  try {
    
  // Pause the decorative effect when its photo is outside the viewport.
  if ('IntersectionObserver' in window) {
    const glitchObserver = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => target.classList.toggle('is-in-view', isIntersecting));
    });
    const observeHeroes = (root) => root.querySelectorAll('.hrny-hero').forEach((hero) => glitchObserver.observe(hero));
    observeHeroes(document);
    document.addEventListener('shopify:section:load', (event) => observeHeroes(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.hrny-hero').forEach((hero) => glitchObserver.unobserve(hero));
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-hrny-size-chart]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.hrnySizeChart);
      if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }
    if (event.target instanceof HTMLDialogElement && event.target.matches('.hrny-size-chart-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
